module.exports = __webpack_public_path__ + "static/media/larry4.a8278e40.mp3";